module.exports = {
          srcSet: __webpack_public_path__ + "2136ebea40f5b7b5ecd4c34ba66890cd-5000.png"+" 5000w",
          images:[ {path: __webpack_public_path__ + "2136ebea40f5b7b5ecd4c34ba66890cd-5000.png",width: 5000,height: 1298}],
          src: __webpack_public_path__ + "2136ebea40f5b7b5ecd4c34ba66890cd-5000.png",
          toString:function(){return __webpack_public_path__ + "2136ebea40f5b7b5ecd4c34ba66890cd-5000.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAX0lEQVR4nDWMsQ3CQBDA7j8pEDOwRDbJBpkrw9HSIBoUhEj+bPQSFO5shxpqVcctrdfDeKbTrbEo5y2JhDGA4SfGvVEejXjD/EpW4bJndrH225+ixEGPOPWbUsD6wfgC7vBalzOilwIAAAAASUVORK5CYII=",
          width: 5000,
          height: 1298
        }